export default function ($http) {
    return function (userId) {
        return $http({
            method: 'GET',
            url: `/api/users/details/${ userId }`,
            headers: {
                'Content-Type': 'application/json'
            }
        })
		.then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/services/details/userDetails.js